import React, { Component } from 'react';
import classNames from 'classnames';
import Link from 'gatsby-link';

import logoImg from '../img/logo.png';

export class Header extends Component {
  renderLogo() {
    return (
      <Link className="header__logo" to="/">
        <img src={logoImg} alt="Dukim s.r.o." />
      </Link>
    );
  }

  renderMenu() {
    return (
      <div className="header__menu">
        <Link to="/">
          <span className="glyphicon glyphicon-home" /> Domů
        </Link>
        <a href="#menu" className="openMenu">
          <span className="glyphicon glyphicon-menu-hamburger" /> Menu
        </a>
      </div>
    );
  }

  render() {
    return (
      <div className="header">
        {this.renderLogo()}
        {this.renderMenu()}
      </div>
    );
  }
}

export default Header;



// WEBPACK FOOTER //
// ./src/components/Header.js